import { render, staticRenderFns, recyclableRender, components } from "./activityApplyItem.vue?vue&type=template&id=150038c6&scoped=true&"
var renderjs
import script from "./activityApplyItem.vue?vue&type=script&lang=js&"
export * from "./activityApplyItem.vue?vue&type=script&lang=js&"
import style0 from "./activityApplyItem.vue?vue&type=style&index=0&id=150038c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150038c6",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/merchant/activityApplyItem.vue"
export default component.exports